// Predefined chat messages for game communication
// No category headings - just a clean list of phrases

export const PREDEFINED_MESSAGES = [
  'Didn\'t see that coming',
  'DPA!',
  'GG',
  'Good game',
  'Good luck',
  'Goodbye',
  'Gotta go',
  'Ha!',
  'Hello',
  'Hi',
  'Hmm…',
  'I\'m in trouble',
  'I\'m still learning',
  'Misclick',
  'Nice move',
  'Oof',
  'Oops',
  'Ouch',
  'Sorry',
  'That was a mistake',
  'That was crazy!',
  'Thanks',
  'Uh oh',
  'Watch your clock!',
  'Wow',
];

// Emojis - separate section (4 columns × 3 rows = 12 emojis)
export const CHAT_EMOJIS = [
  '😏',
  '😮',
  '😬',
  '😈',
  '😎',
  '🔥',
  '👍',
  '👎',
  '😄',
  '🤬',
  '😩',
  '⏰',
];



